import Giftcard from "@screens/product/Giftcard"
import React from "react"

export default () => <Giftcard />
